import React, { useRef } from "react";

import EmailEditor from "react-email-editor";
import { useDispatch } from "react-redux";
import { getRejectionStatuses } from "../../redux/slices/sellerSlice";

const LOCAL_CONSTANT = "react_email_template";

const EmailTemplate = () => {

    const dispatch = useDispatch()
  const emailEditorRef = useRef(null);
  const [preview, setPreview] = React.useState(false);

  React.useEffect(()  => {
    dispatch(getRejectionStatuses())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const exportHtml = () => {
    const unlayer = emailEditorRef.current?.editor;

    unlayer?.exportHtml((data) => {
      const { html } = data;

      const element = document.createElement("a");
    const file = new Blob([html], {type: 'text/html'});
    element.href = URL.createObjectURL(file);
    element.download = "template.html";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();

    document.body.removeChild(element)

    });
  };

  const saveDesign = () => {
    const unlayer = emailEditorRef.current?.editor;
    unlayer?.saveDesign((data) => {
      localStorage.setItem(LOCAL_CONSTANT, JSON.stringify(data));
    });
  };

  const togglePreview = () => {
    const unlayer = emailEditorRef.current?.editor;

    if (preview) {
      unlayer?.hidePreview();
      setPreview(false);
    } else {
      unlayer?.showPreview('desktop');
      setPreview(true);
    }
  };

  const onReady = (unlayer) => {
    const saved = localStorage.getItem(LOCAL_CONSTANT);

    if (saved) unlayer.loadDesign(JSON.parse(saved));

    // editor is ready
    // you can load your template here;
    // the design json can be obtained by calling
    // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)

    // const templateJson = { DESIGN JSON GOES HERE };
    // unlayer.loadDesign(templateJson);
  };

  return (
    <div>
      <div>
      <button onClick={togglePreview}>
         Preview
        </button>
        <button onClick={exportHtml}>Export HTML</button>
        <button onClick={saveDesign}>Save Design</button>
      </div>
      <EmailEditor ref={emailEditorRef} onReady={onReady} />
    </div>
  );
};

export default EmailTemplate;
